import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, FileText, Mountain, Crown, Layers, Plus } from 'lucide-react';
export function ComparePage() {
  const [showEdge, setShowEdge] = useState(false);
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans pb-24" data-id="element-620" data-mp="dhwa376ktw4s">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-16 px-6 md:px-12 max-w-5xl mx-auto text-center" data-id="element-621" data-mp="3htqhvplvdd31">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-622" data-mp="3cv6sff82hj5x" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-623" data-mp="3qvhiig1jytq1">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-624" data-mp="115e6xh4p7kem">
            Your Partnership Options
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-625" data-mp="38tir592ktany">
            <button type="button" onClick={() => setShowEdge(isVisible => !isVisible)} aria-pressed={showEdge} aria-label={`${showEdge ? 'Show two' : 'Show three'} ways to partner`} className="inline-flex items-center rounded-lg text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FE0C3] focus-visible:ring-offset-4 focus-visible:ring-offset-[#0A0F1C]" data-id="element-626" data-mp="3dtenqn8y1zth">
              {showEdge ? 'Three' : 'Two'}
            </button>{' '}
            Ways to Partner
          </h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-627" data-mp="2zvghy68ovbpl">
            A simple side-by-side of everything we discussed, so you can review
            the investment and share it with your team. Every package runs the
            HIRE recruiting system at a different level of ownership and
            execution.
          </p>
        </motion.div>
      </section>

      {/* 2. CORE PACKAGES */}
      <section className={`px-6 md:px-12 ${showEdge ? 'max-w-7xl' : 'max-w-5xl'} mx-auto mb-8 transition-[max-width] duration-300`} data-id="element-628" data-mp="2926lnqww4tcl">
        <div className={`grid grid-cols-1 gap-6 items-stretch ${showEdge ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-id="element-629" data-mp="244eooihe2h1j">
          {showEdge && <motion.article initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.25
        }} className="bg-slate-900/40 border border-slate-600 rounded-2xl p-8 flex flex-col relative" data-id="element-630" data-mp="1ccfiz4eg3zvp">
              <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-631" data-mp="31qvk1i6kakkn">
                <div className="p-2 bg-slate-800 border border-slate-700 rounded-lg" data-id="element-632" data-mp="31syh2m64tdyv">
                  <Layers className="w-6 h-6 text-slate-300" data-id="element-633" data-mp="2wr96t8qqh4bu" />
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-634" data-mp="ij882li990bi">Edge</h2>
              </div>
              <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-635" data-mp="nk5mqo423c89">
                A managed recruiting infrastructure layer for teams that keep
                hiring, onboarding, and training in-house.
              </p>

              <div className="mb-6" data-id="element-636" data-mp="eioa5fpuxsob">
                <div className="flex items-end justify-between mb-5" data-id="element-637" data-mp="1288x09p4ta2v">
                  <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-638" data-mp="12a3flhcxkq3s">
                    Build (One-Time)
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-639" data-mp="siz1skyzrbaj">$3,500</span>
                </div>
                <div className="flex items-end justify-between" data-id="element-640" data-mp="xgh1dkr4ce5v">
                  <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-641" data-mp="1l6uwjk502t4o">
                    Total Monthly
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-642" data-mp="1pymnhvs2j0vc">$2,500</span>
                </div>
                <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-643" data-mp="1ctk5tzblci5">
                  <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-644" data-mp="3sha1ug8pit7i">
                    What makes up the monthly
                  </div>
                  <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-645" data-mp="3jhmyvq0bxfcc">
                    <li className="flex justify-between" data-id="element-646" data-mp="k28gjb429dg7">
                      <span data-id="element-647" data-mp="k1qcvtf2jwy9">System fee</span>
                      <span data-id="element-648" data-mp="g0mzreoeof0q">$1,500</span>
                    </li>
                    <li className="flex justify-between" data-id="element-649" data-mp="g1g5qdfjj0ht">
                      <span data-id="element-650" data-mp="b94tqc7izo8w">Full campaign</span>
                      <span data-id="element-651" data-mp="b7tsaj1jysky">$1,000</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-652" data-mp="13pz3w04vlww6">
                <div className="flex items-baseline justify-between gap-3" data-id="element-653" data-mp="13sbvz64clnmy">
                  <span className="text-xs font-bold uppercase tracking-widest text-slate-400" data-id="element-654" data-mp="yxxwarinkuch">
                    Sales School Tickets
                  </span>
                  <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-655" data-mp="1b98dnuhanxlr">
                    $250
                  </span>
                </div>
                <p className="mt-1 text-right text-sm text-slate-400" data-id="element-656" data-mp="1gaxpvdg96hbf">per ticket</p>
                <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-657" data-mp="1kbzopt69crcv">
                  Purchased separately based on the number of attendees.
                </p>
              </div>

              <div className="flex-1" data-id="element-658" data-mp="1u7b50fxbe6mq">
                <div className="text-sm font-bold text-white mb-3" data-id="element-659" data-mp="1u69nbslsmlw1">What you get:</div>
                <ul className="space-y-2.5" data-id="element-660" data-mp="1z1fdx4q54oqg">
                  {['Custom ATS, application flow, and campaign creative', 'Active job board management and optimization', 'Applicant screening and pre-qualification', 'Candidate handoff to your internal team', 'Multi-market coordination and reporting'].map(item => <li key={item} className="flex items-start text-sm text-slate-300" data-id="element-661" data-mp="8vsmu0bz136w">
                      <Check className="w-4 h-4 text-slate-400 mr-2 mt-0.5 shrink-0" data-id="element-662" data-mp="mme099inokxe" />
                      <span data-id="element-663" data-mp="hvxmfoaxaxai">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-664" data-mp="wk25wuhsvcuc">
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-665" data-mp="rlqx8n38r8dp">
                  <span className="text-white font-medium" data-id="element-666" data-mp="rlh6uyeaaz7h">Best for:</span> teams
                  with strong internal hiring and onboarding who want more
                  predictable candidate flow.
                </p>
              </div>
            </motion.article>}

          {/* ADVANTAGE */}
          <div className="bg-slate-900/60 border border-[#7FE0C3]/40 rounded-2xl p-8 flex flex-col relative" data-id="element-667" data-mp="37ezb35bnclbw">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-668" data-mp="32g67q5q2qapg">
              Most Teams Start Here
            </div>
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-669" data-mp="1948ucrg0rpgo">
              <div className="p-2 bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 rounded-lg" data-id="element-670" data-mp="1d514dmwptye0">
                <FileText className="w-6 h-6 text-[#7FE0C3]" data-id="element-671" data-mp="1d2ofsqwgcprz" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-672" data-mp="z7cl2jiaqzb2">Advantage</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-673" data-mp="145nu4s0rp5s8">
              We build and own the recruiting system, and your team runs the
              interviews. A predictable hiring engine with full accountability.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-674" data-mp="2kjnta0rsgref">
              <div className="flex items-end justify-between mb-5" data-id="element-675" data-mp="2kgi0objyb7dy">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-676" data-mp="2oiwmn4ix2n9g">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-677" data-mp="1ccozotgvzeie">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-678" data-mp="17e3zgu1mwuty">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-679" data-mp="12jq8r4xx3bvm">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-680" data-mp="xk3vwwm03xnc">$5,000</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-681" data-mp="ti0abf5mbcoc">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-682" data-mp="onmkds9q5xr2">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-683" data-mp="eodt5768ux8e">
                  <li className="flex justify-between" data-id="element-684" data-mp="2e0g7y43xb3fq">
                    <span data-id="element-685" data-mp="2dxu3idcbx41q">System fee</span>
                    <span data-id="element-686" data-mp="2926f405o8exa">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-687" data-mp="2hi40y20os5pu">
                    <span data-id="element-688" data-mp="2hhm7fd5es5lm">Campaign management</span>
                    <span data-id="element-689" data-mp="2ljh6sc3s48wr">$2,500</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-690" data-mp="2qa5x3o3q2zub">
              <div className="flex items-baseline justify-between gap-3" data-id="element-691" data-mp="2v9iuv3w4trbo">
                <span className="text-xs font-bold uppercase tracking-widest text-[#7FE0C3]" data-id="element-692" data-mp="2v8r2s31qubq5">
                  Sales School Tickets
                </span>
                <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-693" data-mp="22k3avomhoo3m">
                  $200
                </span>
              </div>
              <p className="mt-1 text-right text-sm text-slate-400" data-id="element-694" data-mp="27m11j3x7yl6l">per ticket</p>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-695" data-mp="2cklxus9cokpr">
                Purchased separately based on the number of attendees.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-696" data-mp="3nwd414ni149u">
              <div className="text-sm font-bold text-white mb-3" data-id="element-697" data-mp="38niav9v34l0m">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-698" data-mp="3dljvw0c2mueq">
                {['Custom ATS, landing pages, and full funnel build', 'Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-699" data-mp="2uplgmk43sqp4" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-700" data-mp="33ofiaowak79j" />
                    <span data-id="element-701" data-mp="dz3o9ww78v5e">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-702" data-mp="ix58wm99x2iz">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-703" data-mp="t1vdz0zz4mrf">
                <span className="text-white font-medium" data-id="element-704" data-mp="t13hlnyjyl03">Best for:</span> teams
                that want recruiting to finally be consistent and predictable,
                while keeping interviews and final decisions in-house.
              </p>
            </div>
          </div>

          {/* SUMMIT */}
          <div className="bg-slate-900/40 border border-amber-500/30 rounded-2xl p-8 flex flex-col relative" data-id="element-705" data-mp="f8dxjp2l3q5m">
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-706" data-mp="a9106ae370os">
              <div className="p-2 bg-amber-500/10 border border-amber-500/20 rounded-lg" data-id="element-707" data-mp="5apqbznskq6k">
                <Mountain className="w-6 h-6 text-amber-400" data-id="element-708" data-mp="dzandfwfwlo" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-709" data-mp="3shrz6vdeu14g">Summit</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-710" data-mp="1urqpcrd356nz">
              Everything in Advantage, plus a dedicated US-based recruiter who
              runs your interviews. Recruiting execution handled entirely for
              you.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-711" data-mp="3ozm95ym5ugld">
              <div className="flex items-end justify-between mb-5" data-id="element-712" data-mp="3ozujbiqwf7sv">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-713" data-mp="3b87m9gp4tv91">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-714" data-mp="3f9j615lbrm9b">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-715" data-mp="6tzjepf5t238">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-716" data-mp="bssuycavyj0r">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-717" data-mp="3txw54bfpll81">$8,000</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-718" data-mp="2qbao3esk0ge">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-719" data-mp="2ihpazse98nkj">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-720" data-mp="2f0be7zt4qook">
                  <li className="flex justify-between" data-id="element-721" data-mp="2azrgov4n9j1w">
                    <span data-id="element-722" data-mp="2az7yddb30snc">System fee</span>
                    <span data-id="element-723" data-mp="2oz0kevbnykoz">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-724" data-mp="2oyhd08jn3ep7">
                    <span data-id="element-725" data-mp="2jzweqeny753e">Campaign management</span>
                    <span data-id="element-726" data-mp="2jy382zdc4kve">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-727" data-mp="1wbd59vt5wm9q">
                    <span data-id="element-728" data-mp="1rbib9je3bgkg">Corporate recruiter</span>
                    <span data-id="element-729" data-mp="1rd39pk3izjnl">$3,000</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-730" data-mp="262hjuuexe541">
              <div className="flex items-baseline justify-between gap-3" data-id="element-731" data-mp="218whyra7oqzk">
                <span className="text-xs font-bold uppercase tracking-widest text-amber-400" data-id="element-732" data-mp="1djk95sisqkxs">
                  Sales School Tickets
                </span>
                <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-733" data-mp="18iwl9fpv6k7s">
                  $150
                </span>
              </div>
              <p className="mt-1 text-right text-sm text-slate-400" data-id="element-734" data-mp="grxe73o8ndb5">per ticket</p>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-735" data-mp="kuk8rccancc1">
                Purchased separately based on the number of attendees.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-736" data-mp="ukn1dbfi6o9u">
              <div className="text-sm font-bold text-white mb-3" data-id="element-737" data-mp="ujlnkz73rnof">
                Everything in Advantage, plus:
              </div>
              <ul className="space-y-2.5" data-id="element-738" data-mp="zl1ayxwr669z">
                {['A dedicated US-based corporate recruiter representing your brand', 'Second-round interview execution handled for you', 'Candidate scheduling and follow-up', 'Full execution accountability'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-739" data-mp="3abrnea3aaso4" data-mpi={i}>
                    <Check className="w-4 h-4 text-amber-400 mr-2 mt-0.5 shrink-0" data-id="element-740" data-mp="2y10elx8el1g7" />
                    <span data-id="element-741" data-mp="2xz758a6eo34i">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-742" data-mp="2p0bvwp82ecwz">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-743" data-mp="2oy8yhk4l1hi8">
                <span className="text-white font-medium" data-id="element-744" data-mp="3lpb8ggfom0uz">Best for:</span> teams
                whose leaders are too busy selling to interview, and want
                recruiting execution fully off their plate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SHARED NOTE */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-20" data-id="element-745" data-mp="37qjxv4012xbl">
        <div className="p-5 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-746" data-mp="21bsqchgege8l">
          <p className="text-[#7FE0C3] text-center text-sm font-medium" data-id="element-747" data-mp="1wb503xzzw1ff">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 4. LEADERSHIP ADD-ON */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-24" data-id="element-748" data-mp="22pu3j5q5vr3r">
        <div className="text-center mb-8" data-id="element-749" data-mp="1ordmakuoai7d">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-4" data-id="element-750" data-mp="1ouhwbyutk85y">
            Optional Add-On
          </div>
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-751" data-mp="1jtki1xcxjy9q">
            Add Leadership to Either Package
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-752" data-mp="1557i6paq1v9y">
            Leadership is an optional add-on that layers onto Advantage or
            Summit. Run it in tandem with your main campaign, or ahead of it to
            put the right manager in place before you scale the team beneath
            them.
          </p>
        </div>

        {/* Visual: Advantage or Summit + Leadership */}
        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4 mb-10" data-id="element-753" data-mp="hhkg89lojin3">
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-slate-700 rounded-xl p-5 text-center" data-id="element-754" data-mp="cizpd0sbibbb">
            <div className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-755" data-mp="qfcv5cnhoo9y">
              Core Package
            </div>
            <div className="text-white font-bold" data-id="element-756" data-mp="10fdirase5qjy">Advantage or Summit</div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-757" data-mp="10dk9dnqe8s89">
              Recruits and ramps your reps
            </div>
          </div>
          <div className="flex items-center justify-center text-slate-500" data-id="element-758" data-mp="1a5yduo8uwcy4">
            <Plus className="w-6 h-6" data-id="element-759" data-mp="1a79l4y1ig2tz" />
          </div>
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-5 text-center" data-id="element-760" data-mp="157ogc6znt09c">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-wider mb-1" data-id="element-761" data-mp="1j4223sb87ntm">
              Add-On
            </div>
            <div className="text-white font-bold flex items-center justify-center" data-id="element-762" data-mp="2ljr8xedwsztp">
              <Crown className="w-4 h-4 text-[#7FE0C3] mr-2" data-id="element-763" data-mp="2lltu9l44a4s3" />
              Leadership
            </div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-764" data-mp="2uk5veh2m0kys">
              Recruits the managers who lead them
            </div>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-8" data-id="element-765" data-mp="2zhyxoz0skuts">
          <div className="flex flex-col md:flex-row gap-10" data-id="element-766" data-mp="22u13zygfmxo2">
            <div className="flex-1" data-id="element-767" data-mp="26ul0r0x3fz9o">
              <div className="text-sm font-bold text-white mb-3" data-id="element-768" data-mp="26vmmbzbqk45n">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-769" data-mp="2bs4piurf3ufv">
                {['Targeted outreach to experienced operators and team leaders', 'Interviews handled for you', 'Vetted candidates passed to you for final approval only', 'Performance aligned to the leader and their team output'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-770" data-mp="1gjj9a8b23zro" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-771" data-mp="1bjohm2jgj65k" />
                    <span data-id="element-772" data-mp="16kle4mj4l7zp">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="w-full md:w-72 shrink-0 space-y-4 md:border-l md:border-slate-800 md:pl-10" data-id="element-773" data-mp="12n5q8uqvjqb3">
              <div className="flex items-end justify-between" data-id="element-774" data-mp="xnjb2frhjzzn">
                <span className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-775" data-mp="stf785dio82s">
                  Build (One-Time)
                </span>
                <span className="text-xl font-bold text-white" data-id="element-776" data-mp="iwu27k1hywyy">$7,500</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-777" data-mp="ev8qw34m2qqv">
                Covers build and implementation of standard and leadership
                campaign.
              </p>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-778" data-mp="9y8llufl5s0t">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-779" data-mp="2uvzc85xibta5">
                  Monthly Management
                </span>
                <span className="text-xl font-bold text-white" data-id="element-780" data-mp="2lwvqsvavb1sh">$2,500</span>
              </div>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-781" data-mp="2gytxlhjq9m3a">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-782" data-mp="2byza7nz5vemz">
                  Performance
                </span>
                <span className="text-xl font-bold text-white" data-id="element-783" data-mp="277plcplfsfc5">2.5%</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-784" data-mp="237p5r1mlpy3i">
                Of revenue, capped at $15,000. Based on the leader's personal
                and team production combined.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. HOW TO CHOOSE */}
      <section className="px-6 md:px-12 max-w-3xl mx-auto" data-id="element-785" data-mp="1oaodmx0i014i">
        <div className="text-center mb-10" data-id="element-786" data-mp="1e5q3vdntwhvy">
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-787" data-mp="1e4wt81lr188j">How to choose</h2>
          <p className="text-slate-400" data-id="element-788" data-mp="1j401dux0zukq">
            A quick way to land on the right fit for where your team is today.
          </p>
        </div>

        <div className="space-y-4" data-id="element-789" data-mp="1o1t5mierqeid">
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-790" data-mp="1t2pbh1iokaqf">
            <FileText className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-791" data-mp="vfqib0r75kxa" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-792" data-mp="10eb9ybsduwa4">
              <span className="text-white font-medium" data-id="element-793" data-mp="10ekyrw1oyxe8">Choose Advantage</span>{' '}
              if your team can run interviews well and you mainly need a
              recruiting system that produces consistent, qualified candidates.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-amber-500/20 rounded-xl p-5" data-id="element-794" data-mp="cnnzbir31sjv">
            <Mountain className="w-5 h-5 text-amber-400 mr-4 mt-0.5 shrink-0" data-id="element-795" data-mp="hms9abltzub9" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-796" data-mp="9mm4pc3oxeq8">
              <span className="text-white font-medium" data-id="element-797" data-mp="9krlq3bzbwos">Choose Summit</span> if
              interviewing is eating your leadership's time and you want a
              recruiter to handle execution end to end.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-798" data-mp="edkqgr7g750v">
            <Crown className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-799" data-mp="3mup9l2jhni7g" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-800" data-mp="3hut7x9y9k2v2">
              <span className="text-white font-medium" data-id="element-801" data-mp="3hwnokc2i58tc">Add Leadership</span> to
              either package when you also need to recruit the managers and team
              leaders who will scale your operation.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-802" data-mp="1c0jslhgwt565">
          <p className="text-slate-500 text-sm max-w-xl mx-auto leading-relaxed" data-id="element-803" data-mp="1c3fnsy1dhfqw">
            Most partners start with Advantage as the foundation, then add
            Summit for execution or Leadership for management hiring as their
            needs grow.
          </p>
        </div>
      </section>
    </div>;
}